'use strict'
document.addEventListener("DOMContentLoaded", () => {
    /*********************************
     * Header Sticky (mega menu)
     ********************************/
    const megaMenuWrap = document.querySelector('.header-megaMenu-box');

    if(megaMenuWrap){
        const megaMenuWrapHeight = megaMenuWrap.offsetHeight;

        /*** navigation single product (Table of content) ***/
        const tableOfContent = document.querySelector('.sticky-tabs');

        if(tableOfContent && tableOfContent.classList.contains('has-mega-menu')){
            tableOfContent.style.top = `${megaMenuWrapHeight}px`;
        }
    }

    /*********************************
     * Section: banner-slider-box.liquid
     ********************************/
    const sectionBannerSlider = document.querySelectorAll('.banner-slider');

    sectionBannerSlider.forEach(section  =>{
        const bannerSlider = section.querySelector('.init-slider-banner');
        if(bannerSlider){
            $(bannerSlider).slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: true,
                infinite: true,
                speed: 1500,
                prevArrow:"<button type='button' class='slick-prev pull-left'><i class='fa fa-angle-left' aria-hidden='true'></i></button>",
                nextArrow:"<button type='button' class='slick-next pull-right'><i class='fa fa-angle-right' aria-hidden='true'></i></button>"
            });
        }
    });

    /*********************************
     * Section Shop country
     ********************************/
    const sectionShopsCountry = document.querySelector('.shops-country');

    if(sectionShopsCountry){
        const shopsNavigation = document.querySelector('.shop-navigation');
        const regionGroup = document.querySelector('.region-group');

        shopsNavigation.addEventListener('click', ({target}) =>{

            if(target.classList.contains('nav-item') && !target.classList.contains('active')){
                const tabActive = shopsNavigation.querySelector('.nav-item.active');
                const tabRegionActive = sectionShopsCountry.querySelector('.region-tab.active');
                const tabRegionGroup = sectionShopsCountry.querySelectorAll('.region-tab');
                const navIndex = target.getAttribute('data-nav');

                tabActive.classList.remove('active');
                tabRegionActive.classList.remove('active');

                target.classList.add('active');

                if(window.innerWidth <= 992){
                    const elementPosition = document.querySelector('.page-banner')?.getBoundingClientRect().top;

                    window.scrollTo({
                        top: elementPosition,
                        behavior: 'smooth'
                    });
                }

                tabRegionGroup.forEach(region =>
                    region.getAttribute('tab-region') === navIndex ?
                        region.classList.add('active') : ''
                )
            }
        })

        regionGroup.addEventListener('click', function ({target}){
            const regionActive = document.querySelector('.region-group-item.active');
            const regionItem = target.closest('.region-group-item');
            const regionInfo = regionItem.querySelector('.info');

            if(regionItem.classList.contains('active')){
                regionItem.classList.remove('active');
                regionInfo.style.height = 0 + 'px';
            }else{
                if(regionActive){
                    regionActive.classList.remove('active');
                    regionActive.querySelector('.info').style.height = 0 + 'px';
                }
                regionItem.classList.add('active');
                regionInfo.style.height = regionInfo.scrollHeight + "px";
            }
        });
    }

    /*********************************
     * Section: Comparison
     ********************************/
    const tableComparison = document.querySelector('.comparison-table');

    if(tableComparison){
        const itemsToCompare = Array.from(tableComparison.querySelectorAll('.item-to-compare .item-height'));
        const itemCompared = tableComparison.querySelector('.item-compared');

        itemsToCompare.forEach(div =>{
            const tableItemCompared = itemCompared.querySelector(`.${div.getAttribute('class').split(' ')[0]}`);

            div.scrollHeight > tableItemCompared.scrollHeight
                ? tableItemCompared.style.minHeight = `${div.scrollHeight}px`
                : div.style.minHeight = `${tableItemCompared.scrollHeight}px`
        });
    }

    /*********************************
     * Product: Swatch
     ********************************/
    const product = document.querySelector('.main-box-product');

    if (product && !product.classList.contains('gift-card')) {
        const productVariants = {
            color: product.querySelector('#product-variants #Color'),
            size: product.querySelector('#product-variants #Size'),
            shipping_label: product.querySelector('#product-variants #shipping_label'),
        };

        window.addEventListener('DOMContentLoaded', () => {
            const checkedInputs = [];

            if (productVariants.color) {
                checkedInputs.push(...productVariants.color.querySelectorAll('input[type="radio"]:checked'));
            }

            if (productVariants.size) {
                checkedInputs.push(...productVariants.size.querySelectorAll('input[type="radio"]:checked'));
            }

            if (productVariants.shipping_label) {
                checkedInputs.push(...productVariants.shipping_label.querySelectorAll('input[type="radio"]:checked'));
            }

            const isSoldOut = checkedInputs.length ? checkedInputs.some((input) => input.classList.contains('soldout')) : true;
            product.classList.toggle('sold-out', isSoldOut)
        });

        const handleVariantClick = ({ target }) => {
            if (target.closest('.swatch-element')) {
                const input = target.closest('.swatch-element').querySelector('input');
                product.classList.toggle('sold-out', input.classList.contains('soldout'))
            }
        };

        productVariants.color?.addEventListener('click', handleVariantClick);
        productVariants.size?.addEventListener('click', handleVariantClick);
    }

  /*********************************
   * Section: Section products list
   ********************************/
  const sectionProductList = document.querySelector('#section-products-list');

  if(sectionProductList){
    const slider = sectionProductList.querySelector('.products-slider-init');
    const sliderItem = Array.from(slider.querySelectorAll('.slide-item'));

    const sliderInit = () =>{
      $(slider).slick({
        slidesToShow: 2,
        slidesToScroll: 1,
        arrows: false,
        dots: true,
        infinite: true,
        speed: 1500,
        responsive: [
          {
            breakpoint: 992,
            settings: {
              slidesToShow: 1,
            }
          },
        ]
      });
    }

    if(sliderItem.length > 2 && window.innerWidth >= 992){
      sliderInit();
    }

    if(sliderItem.length > 1 && window.innerWidth <= 991){
      sliderInit();
    }
  }
});